<template>
  <div @click="goHome">
    <canvas id="heart" />
  </div>
</template>

<script>
// https://codepen.io/tvolodimir/pen/wqKuJ

import Keypress from 'keypress.js';

export default {
  data() {
    return {
      pause: true,
      timeout: null,
      loop: null,
      canvas: null,
      delay: 100,
      random: false,
      heart: {
        pos1: 3,
        pos2: 15,
        pos3: 5,
        pos4: 2,
        pos5: 2,
        pos6: 3,
        pos7: 4,
      },
    };
  },
  mounted() {
    this.init();

    const listener = new Keypress.Listener();

    listener.simple_combo('space', () => {
      this.pause = !this.pause;

      if (this.pause) {
        clearTimeout(this.timeout);
        window.requestAnimationFrame(this.loop, this.canvas);
      }
    });

    listener.simple_combo('r', () => {
      this.random = !this.random;

      if (this.random) {
        this.heart = {
          pos1: Math.floor(Math.random() * 3) + 1,
          pos2: Math.floor(Math.random() * 15) + 1,
          pos3: Math.floor(Math.random() * 5) + 1,
          pos4: Math.floor(Math.random() * 2) + 1,
          pos5: Math.floor(Math.random() * 2) + 1,
          pos6: Math.floor(Math.random() * 3) + 1,
          pos7: Math.floor(Math.random() * 4) + 1,
        };
      } else {
        this.heart = {
          pos1: 3,
          pos2: 15,
          pos3: 5,
          pos4: 2,
          pos5: 2,
          pos6: 3,
          pos7: 4,
        };
      }

      this.init();
    });

    listener.simple_combo('up', () => {
      this.delay += 100;
    });

    listener.simple_combo('down', () => {
      if (this.delay >= 100) {
        this.delay -= 100;
      }
    });
  },

  methods: {
    init() {
      window.isDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test((navigator.userAgent || navigator.vendor || window.opera).toLowerCase());
      let loaded = false;
      const init = () => {
        if (loaded) return;
        loaded = true;
        const mobile = window.isDevice;
        const koef = mobile ? 0.5 : 1;
        this.canvas = document.getElementById('heart');
        const ctx = this.canvas.getContext('2d');
        let width = (this.canvas.width = koef * innerWidth);
        let height = (this.canvas.height = koef * innerHeight);
        const rand = Math.random;
        ctx.fillStyle = 'rgba(0,0,0,1)';
        ctx.fillRect(0, 0, width, height);

        const heartPosition = (rad) => [Math.pow(Math.sin(rad), this.heart.pos1), -(this.heart.pos2 * Math.cos(rad) - this.heart.pos3 * Math.cos(this.heart.pos4 * rad) - this.heart.pos5 * Math.cos(this.heart.pos6 * rad) - Math.cos(this.heart.pos7 * rad))];
        const scaleAndTranslate = (pos, sx, sy, dx, dy) => [dx + pos[0] * sx, dy + pos[1] * sy];

        window.addEventListener('resize', () => {
          width = this.canvas.width = koef * innerWidth;
          height = this.canvas.height = koef * innerHeight;
          ctx.fillStyle = 'rgba(0,0,0,1)';
          ctx.fillRect(0, 0, width, height);
        });

        const traceCount = mobile ? 20 : 50;
        const pointsOrigin = [];
        let i;
        const dr = mobile ? 0.3 : 0.1;
        for (i = 0; i < Math.PI * 2; i += dr) pointsOrigin.push(scaleAndTranslate(heartPosition(i), 210, 13, 0, 0));
        for (i = 0; i < Math.PI * 2; i += dr) pointsOrigin.push(scaleAndTranslate(heartPosition(i), 150, 9, 0, 0));
        for (i = 0; i < Math.PI * 2; i += dr) pointsOrigin.push(scaleAndTranslate(heartPosition(i), 90, 5, 0, 0));
        const heartPointsCount = pointsOrigin.length;

        const targetPoints = [];
        const pulse = function (kx, ky) {
          for (i = 0; i < pointsOrigin.length; i += 1) {
            targetPoints[i] = [];
            targetPoints[i][0] = kx * pointsOrigin[i][0] + width / 2;
            targetPoints[i][1] = ky * pointsOrigin[i][1] + height / 2;
          }
        };

        const e = [];
        for (i = 0; i < heartPointsCount; i += 1) {
          const x = rand() * width;
          const y = rand() * height;
          e[i] = {
            vx: 0,
            vy: 0,
            R: 2,
            speed: rand() + 5,
            q: ~~(rand() * heartPointsCount),
            D: 2 * (i % 2) - 1,
            force: 0.2 * rand() + 0.7,
            f: `hsla(178,${~~(40 * rand() + 60)}%,${~~(60 * rand() + 20)}%,.3)`,
            trace: [],
          };
          for (var k = 0; k < traceCount; k += 1) e[i].trace[k] = { x, y };
        }

        const config = {
          traceK: 0.4,
          timeDelta: 0.01,
        };

        let time = 0;
        this.loop = () => {
          const n = -Math.cos(time);
          pulse((1 + n) * 0.5, (1 + n) * 0.5);
          time += (Math.sin(time) < 0 ? 9 : n > 0.8 ? 0.2 : 1) * config.timeDelta;
          ctx.fillStyle = 'rgba(0,0,0,.1)';
          ctx.fillRect(0, 0, width, height);
          for (i = e.length; (i -= 1);) {
            const u = e[i];
            const q = targetPoints[u.q];
            const dx = u.trace[0].x - q[0];
            const dy = u.trace[0].y - q[1];
            const length = Math.sqrt(dx * dx + dy * dy);
            if (length < 10) {
              if (rand() > 0.95) {
                u.q = ~~(rand() * heartPointsCount);
              } else {
                if (rand() > 0.99) {
                  u.D *= -1;
                }
                u.q += u.D;
                u.q %= heartPointsCount;
                if (u.q < 0) {
                  u.q += heartPointsCount;
                }
              }
            }
            u.vx += (-dx / length) * u.speed;
            u.vy += (-dy / length) * u.speed;
            u.trace[0].x += u.vx;
            u.trace[0].y += u.vy;
            u.vx *= u.force;
            u.vy *= u.force;
            for (k = 0; k < u.trace.length - 1;) {
              const T = u.trace[k];
              const N = u.trace[++k];
              N.x -= config.traceK * (N.x - T.x);
              N.y -= config.traceK * (N.y - T.y);
            }
            ctx.fillStyle = u.f;
            for (k = 0; k < u.trace.length; k += 1) {
              ctx.fillRect(u.trace[k].x, u.trace[k].y, 1, 1);
            }
          }

          if (this.pause) {
            window.requestAnimationFrame(this.loop, this.canvas);
          } else {
            this.timeout = setTimeout(() => {
              window.requestAnimationFrame(this.loop, this.canvas);
            }, this.delay);
          }
        };

        this.loop();
      };

      const s = document.readyState;
      if (s === 'complete' || s === 'loaded' || s === 'interactive') init();
      else document.addEventListener('DOMContentLoaded', init, false);
    },

    goHome() {
      this.$router.push('/');
    },
  },
};
</script>
<style>
canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
</style>
